import { jsx as _jsx } from "react/jsx-runtime";
import { useState, createRef, useMemo } from 'react';
import { TextField } from '@mui/material';
import useStyles from './styles';
const OTPInput = ({ length = 6, spacingInterval = 3, onChange = () => { }, autoFocus = true, size = 'medium' }) => {
    const { cx, classes } = useStyles();
    const [otpValue, setOtpValue] = useState(Array.from({ length }, () => ''));
    const inputRefs = useMemo(() => Array.from({ length }, () => createRef()), []);
    const onChangeOtpValue = (index) => (e) => {
        const tmpOtp = otpValue.map((v, i) => i == index ? e.target.value[0] : v);
        setOtpValue(tmpOtp);
        onChange(tmpOtp.join(''));
        moveToNextInput(index, e.target.value);
    };
    const moveToNextInput = (index, val) => {
        const nextLogicalIndex = index + (val == '' ? -1 : 1);
        moveToInputAtIndex(nextLogicalIndex);
    };
    const moveToInputAtIndex = (index) => {
        var _a, _b;
        const clampedNextIndex = Math.min(Math.max(index, 0), length - 1);
        (_a = inputRefs[clampedNextIndex].current) === null || _a === void 0 ? void 0 : _a.focus();
        (_b = inputRefs[clampedNextIndex].current) === null || _b === void 0 ? void 0 : _b.select();
    };
    const handleKeyUp = (index) => (e) => {
        if (e.code == 'Backspace' && e.target.value == '') {
            moveToInputAtIndex(index - 1);
        }
        if (e.key == e.target.value)
            moveToInputAtIndex(index + 1);
    };
    const handleFocus = (e) => e.target.select();
    return (_jsx("div", Object.assign({ className: classes.OtpContainer }, { children: otpValue.map((v, i) => (_jsx(TextField, { autoFocus: autoFocus && i == 0, inputRef: inputRefs[i], variant: 'outlined', placeholder: '-', autoComplete: "one-time-code", className: cx(classes.OtpInput, size == 'small' && classes.SmallInputs), onChange: onChangeOtpValue(i), onKeyUp: handleKeyUp(i), onFocus: handleFocus, value: v || '', style: i > 0 && i % spacingInterval == 0 ? { marginLeft: '16px' } : {} }, i))) })));
};
export default OTPInput;
//# sourceMappingURL=index.js.map